import { render } from "./OtherPaiementDeleted.vue?vue&type=template&id=282ea160"
import script from "./OtherPaiementDeleted.vue?vue&type=script&lang=js"
export * from "./OtherPaiementDeleted.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__